import { motion } from "framer-motion";
import { useEffect } from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { usePost, usePostValue } from "..";
import { DP } from "../../../common/types";
import { useStateReducer } from "../../../hooks/useStateReducer";
import { fetchGetComments } from "../api";
import Comment from "./Comment";

interface Props extends DP {}

const Comments = (props: Props) => {
  const [state, setState] = useStateReducer({ isLoading: false });

  const { set: setPostContext } = usePost();
  const postId = usePostValue((s) => s.post._id);
  const isCommentsHidden = usePostValue((s) => s.isCommentsHidden);
  const comments = usePostValue((s) => s.comments);

  useEffect(() => {
    fetchGetComments(postId).then((comments) => setPostContext({ comments }));
  }, []);

  if (state.isLoading) return <>LOADING</>;

  return (
    <AnimWrapper
      isCommentsHidden={isCommentsHidden}
      animate={isCommentsHidden ? "hidden" : "shown"}
      initial="hidden"
      variants={{
        hidden: { maxHeight: "var(--comment-height)" },
        shown: { maxHeight: "calc(var(--comment-height) * 5)" },
      }}
      className={props.className}
    >
      {comments.map((el, i) => (
        <Comment comment={el} key={el._id}>
          {el.text}
        </Comment>
      ))}
    </AnimWrapper>
  );
};

const AnimWrapper = styled(motion.div)(
  ({ isCommentsHidden }: { isCommentsHidden: boolean }) => [
    tw`space-y-3 overflow-hidden`,
    !isCommentsHidden && tw`overflow-y-auto`,
  ]
);

export default styled(Comments)``;
